// Why the recharge CTA is disabled, or undefined when it is not. Shared by both
// recharge modals so the rule has one owner.
//
// RISK STATUS IS DELIBERATELY NOT AN INPUT (SER-6484). The monthly cap was dropped
// backend-side, but the console kept enforcing it and dead-ended blocked accounts.
// A resolver with no risk parameter makes re-adding that a visible signature change
// rather than a conjunct someone slips back into a modal.
export type RechargeCtaMethod = 'card' | 'netbanking' | 'bank_transfer'

export const resolveRechargeCtaBlocker = ({
  selectedAmount,
  method,
  netbankingDisabledReason,
  bankTransferDisabledReason,
  cardBlocker,
}: {
  selectedAmount: number
  method: RechargeCtaMethod
  // Each bank rail's own INR floor. Gateway rules, not risk ones, so they stay.
  netbankingDisabledReason?: string
  bankTransferDisabledReason?: string
  // The card path's own reason: no card to charge, or incomplete card entry.
  cardBlocker?: string
}): string | undefined => {
  if (!selectedAmount) return 'Select a recharge amount'
  if (method === 'netbanking') return netbankingDisabledReason
  if (method === 'bank_transfer') return bankTransferDisabledReason
  return cardBlocker
}
